import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  TextField,
  Select,
  MenuItem,
  FormControl,
  Button,
  Card,
  CardContent,
  Stack,
  InputAdornment,
  Divider,
  InputLabel,
  useTheme
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { Dayjs } from 'dayjs';

interface FrequencyOptions {
  frequency?: any;
  timeZone?: any;
  date?: any;
  timeOptions?: any;
  Days?: any;
}

interface ScheduleFormProps {
  isScheduled: boolean;
  selectedFrequency: string;
  handleFrequencyChange: (e: any) => void;
  scheduleOptions: any;
  isOtherFrequency: () => boolean;
  selectedDate: any;
  handleDateChange: (newDate: any) => void;
  isWeekly: () => boolean;
  selectedDay: string;
  handleDayChange: (e: any) => void;
  isHourly: () => boolean;
  selectedTime: string;
  scanName: string;
  handleTimeChange: (e: any) => void;
  parentTimeOptions: any[];
  scan_uuid?: string | null;
  handleSave: () => void;
  handleCancel: () => void;
  handleEdit: () => void;
  handleScanNameChange: (newScanName: string) => void;
  hasAddedAssets?: boolean;
}

const AddScheduleForm: React.FC<ScheduleFormProps> = ({
  isScheduled,
  selectedFrequency,
  handleFrequencyChange,
  scheduleOptions,
  isOtherFrequency,
  selectedDate,
  handleDateChange,
  isWeekly,
  selectedDay,
  handleDayChange,
  isHourly,
  selectedTime,
  handleTimeChange,
  parentTimeOptions,
  scan_uuid,
  handleSave,
  handleCancel,
  handleEdit,
  scanName,
  handleScanNameChange
  ,
  hasAddedAssets = true
}) => {
  const [formData, setFormData] = useState({
    scanName: scanName,           // Scan Name
    frequency: selectedFrequency,  // Set initial value from state
    time: selectedTime,          // Time value
    date: selectedDate!=null ? selectedDate.format("YYYY-MM-DD") : "", // Date in string format
    selectedDay: selectedDay,  // Selected Day
  });



  const [isFormValid, setIsFormValid] = useState(false);
 const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";


  const selectedFrequencyObj = scheduleOptions?.frequency?.find(
    (f: any) => f.id === formData.frequency
  );



  useEffect(() => {
    if (scanName) {
      setFormData((prevData) => ({
        ...prevData,
        scanName: scanName,  // Update state if scanName is provided
      }));
    }
    // Apply the validation logic based on the selected frequency
    const selectedFrequencyObj = scheduleOptions?.frequency?.find(
      (f: any) => f.id === formData.frequency
    );

    const isValid =
      selectedFrequencyObj &&
      selectedFrequency !== null &&
      // Scenario 1: Weekly -> On Day & Time are mandatory
      ((selectedFrequencyObj?.name === "Weekly" &&
        formData.selectedDay !== null &&
        formData.time !== "") ||
        // Scenario 2: Hourly -> Time is mandatory
        (selectedFrequencyObj?.name === "Hourly" && formData.time !== "") ||
        // Scenario 3: Other frequencies -> Date & Time are mandatory
        (selectedFrequencyObj?.name !== "Weekly" &&
          selectedFrequencyObj?.name !== "Hourly" &&
          formData.date !== "" &&
          formData.time !== ""));

    setIsFormValid(isValid);
  }, [selectedFrequency, selectedFrequencyObj, scanName]);


  const handleFieldChange = (field: string, value: string) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };
  const [isEditMode, setIsEditMode] = useState(scan_uuid ? true : false);
  const handleEnableEdit = () => {
    setIsEditMode(false);
  };

  const handleCancelEdit = () => {
    setIsEditMode(true);
    // Optionally reset form to the original values
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newScanName = e.target.value;
    setFormData((prevData) => ({
      ...prevData,
      scanName: newScanName,
    }));
    handleScanNameChange(newScanName); // Call parent handler to update the global state
  };

  const handleCancelSchedule = () => {
    handleCancel(); // Call the cancel function passed from parent
  };

  const isFormValidOne = () => {
  if (!selectedFrequency || !selectedTime) return false;
  if (isOtherFrequency()) {
    if (!selectedDate) return false;
  }
  if (isWeekly()) {
    if (!selectedDay) return false;
  }
  return true;
};





  return (
    <Card sx={{ mb: 3, borderRadius: '8px',boxShadow: 0 }}>
      <CardContent >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
            {scan_uuid ? 'Edit Schedule' : 'Create Schedule'}
          </Typography>
          <Box>
            {isEditMode ? (
              <>
                <Button
                  variant="outlined"
                  color="primary"
                  size="small"
                  sx={{ mr: 2 }}
                  onClick={handleEnableEdit} // Trigger edit mode
                >
                  Edit
                </Button>
                <Button
                  variant="outlined"
                  color="error"
                  size="small"
                  onClick={handleCancelSchedule} // Cancel schedule (for when not in edit mode)
                >
                  Cancel Schedule
                </Button>
              </>
            ) : (
              <>
                <Button
                  variant="outlined"
                  color="primary" 
                  size="small"
                  sx={{ mr: 2 }}
                  disabled={!isFormValidOne() || !hasAddedAssets} 
                  onClick={handleSave} 
                >
                  Save
                </Button>
                <Button
                  variant="outlined"
                  color="error"
                  size="small"
                  onClick={handleCancelEdit}
                >
                  Cancel
                </Button>
              </>

            )}
          </Box>
          {/* <Box>
            {isEditMode ? (
              <>
                <Button
                  variant="outlined"
                  color="primary"
                  size="small"
                  sx={{ mr: 2 }}
                  onClick={handleEdit}
                >
                  Edit
                </Button>
                <Button
                  variant="outlined"
                  color="error"
                  size="small"
                  onClick={handleCancel}
                >
                  Cancel Schedule
                </Button>
              </>
            ) : (
              <>
                <Button
                  variant="outlined"
                  color="primary"
                  size="small"
                  sx={{ mr: 2 }}
                  // disabled={!isFormValid}
                  onClick={handleSave}
                >
                  Save
                </Button>
                <Button
                  variant="outlined"
                  color="error"
                  size="small"
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
              </>
            )}
          </Box> */}

          {/* <Box>
            <Button
              variant="outlined"
              size="small"
              sx={{
                mr: 2,
                borderColor: '#4048ee',
                color: '#4048ee',
                '&:hover': {
                  borderColor: '#3038ee',
                  backgroundColor: 'rgba(64, 72, 238, 0.04)',
                }
              }}
            >
              Edit
            </Button>
            <Button
              variant="outlined"
              size="small"
              sx={{
                borderColor: '#4048ee',
                color: '#4048ee',
                '&:hover': {
                  borderColor: '#3038ee',
                  backgroundColor: 'rgba(64, 72, 238, 0.04)',
                }
              }}
            >
              Cancel Schedule
            </Button>
          </Box> */}
        </Box>
        <Divider sx={{ mb: 4 }} variant='fullWidth' />

        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={2}
          sx={{ width: '100%' }}
        >
          <Box sx={{ flex: 1 }}>
            {/* <Typography variant="caption" component="div" sx={{ mb: 1, fontWeight: 'medium', color: '#666' }}>
              Scan Name
            </Typography> */}
            <TextField
              fullWidth
              variant="outlined"
              label="Scan Name"
              
              // disabled={isScheduled}
              placeholder='Enter scan name'
              disabled={isEditMode}
              value={formData.scanName}
              onChange={handleInputChange}
              size="medium"



              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '4px',
                  height: '48px',
                },
              }}
            />
          </Box>

          <Box sx={{ flex: 1 }}>
            {/* <Typography variant="caption" component="div" sx={{ mb: 1, fontWeight: 'medium', color: '#666' }}>
              Frequency
            </Typography> */}
            <FormControl fullWidth size="small">
              <InputLabel>Frequency</InputLabel>
              <Select
                value={selectedFrequency || ""}
                onChange={handleFrequencyChange}
                disabled={isEditMode}
                label="Frequency"
                //disabled={isScheduled}
                sx={{
                  borderRadius: '4px',
                  mb: 3,
                  backgroundColor: isDarkMode ? '#191C24' : 'white',
                   height: "40px",
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    //borderColor: "black",
                  },
                   '& .MuiSelect-select:focus': {
                      backgroundColor: isDarkMode ? '#191C24' : 'white',
                    },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    //borderColor: "black",
                  },
                }}
              //     sx={{
              //   '& .MuiOutlinedInput-root': {
              //     borderRadius: '4px',
              //   }
              // }}
              >
                {scheduleOptions?.frequency?.map((option: any) => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          {isOtherFrequency() && (<>
            <Box sx={{ flex: 1 }}>
              {/* <Typography variant="caption" component="div" sx={{ mb: 1, fontWeight: 'medium', color: '#666' }}>
              On Date
            </Typography> */}
              <FormControl fullWidth size="small">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="On Date"
                    value={selectedDate}
                    // disabled={isScheduled}
                    onChange={handleDateChange}
                    disabled={isEditMode}
                    sx={{
                      width: "100%",
                      backgroundColor: isDarkMode ? '#191C24' : 'white',
                      borderRadius: '4px',
                      mb: 3,
                      "& .MuiOutlinedInput-root": {
                        height: "48px",
                        minHeight: "48px",
                        borderRadius: "4px",
                        "& input": {
                          height: "48px",
                          padding: "14px 14px",
                          boxSizing: "border-box",
                        },
                        "& .MuiInputAdornment-root": {
                          "& button": {
                            outline: "none", 
                            border: "none", 
                          },
                        },
                      },
                    }}
                  />
                </LocalizationProvider>
              </FormControl>
            </Box>
          </>)}

          {isWeekly() && (<>
            <Box sx={{ flex: 1 }}>
              <FormControl fullWidth size="small" required>
                <InputLabel>On Day</InputLabel>
                <Select
                  value={selectedDay || ""}
                  onChange={handleDayChange}
                  label="On Day"
                  sx={{
                    backgroundColor: isDarkMode ? '#191C24' : 'white',
                    borderRadius: '4px',
                    height: '48px',
                    '& .MuiOutlinedInput-root': {
                      height: '48px',
                      minHeight: '48px',
                      borderRadius: '4px',
                    },
                    '& .MuiSelect-select': {
                      minHeight: '30px',
                      height: '48px',
                      display: 'flex',
                      alignItems: 'center',
                    },
                    '& .MuiSelect-select:focus': {
                      backgroundColor: isDarkMode ? '#191C24' : 'white',
                    }
                  }}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        borderRadius: '4px',
                        mt: 0.5,
                        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                      },
                    },
                  }}
                >
                  {scheduleOptions?.Days?.map((day: any) => (
                    <MenuItem key={day.id} value={day.id}>
                      {day.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </>)}
          <Box sx={{ flex: 1 }}>
            <FormControl fullWidth required size="small">
              <InputLabel>{isHourly() ? "Start Time" : "At Time"}</InputLabel>
              <Select
                value={selectedTime || ""}
                onChange={handleTimeChange}
                label="At Time"
                disabled={isEditMode}
                sx={{
                  backgroundColor: isDarkMode ? '#191C24' : 'white',
                  borderRadius: '4px',
                  height: "40px",
                  "& .MuiOutlinedInput-notchedOutline": {
                    //orderColor: "black",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    //borderColor: "black",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    //borderColor: "black",
                  },
                   '& .MuiSelect-select:focus': {
                      backgroundColor: isDarkMode ? '#191C24' : 'white',
                    }
                }}
              >
                {parentTimeOptions?.map((time: any, index: any) => (
                  <MenuItem key={index} value={time}>
                    {time}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {/* <Typography variant="caption" component="div" sx={{ mb: 1, fontWeight: 'medium', color: '#666' }}>
              At time
            </Typography> */}
            {/* <FormControl fullWidth size="small">
              <Select
                value={time}
                onChange={(e) => setTime(e.target.value as string)}
                displayEmpty
                IconComponent={KeyboardArrowDownIcon}
                sx={{
                  borderRadius: '4px',
                  '& .MuiSelect-select': {
                    minHeight: '30px', // <-- Increase height here
                    display: 'flex',
                    alignItems: 'center',
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      borderRadius: '4px',
                      mt: 0.5,
                      boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                    },
                  },
                }}
              >
                <MenuItem value="12:21 AM">12:21 AM</MenuItem>
                <MenuItem value="1:00 AM">1:00 AM</MenuItem>
                <MenuItem value="2:00 AM">2:00 AM</MenuItem>
              </Select>
            </FormControl> */}
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default AddScheduleForm;